<mat-card class="card mat-elevation-z0">
  <mat-card-content>
    <div fxLayout="row" fxLayoutAlign="start center" class="pageTitle">{{title}}</div>
    <mat-divider></mat-divider>

    <div style="margin-top:20px;">
    Ρόλος: {{role.role_name}}
    </div>


    <div style="width:100%; height:400px; margin-top:20px;">

      <div style="height:400px; overflow-y: auto;">
        <table mat-table [dataSource]="actions">
          <mat-card *ngIf="isActionsLoading" style="display: flex; justify-content: center; align-items: center"
                    class="mat-elevation-z0">
            <mat-progress-bar
              color="primary"
              mode="indeterminate">
            </mat-progress-bar>
          </mat-card>

          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>Επιλέξτε</th>
            <td mat-cell *matCellDef="let action" style="justify-content: left; text-align: center;">
              <mat-checkbox [checked]="action.checked" (change)="actionSelected(action, $event)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container *ngIf="mode === 0" matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Ενέργεια</th>
            <td mat-cell *matCellDef="let action"> {{action.description}} </td>
          </ng-container>

          <ng-container *ngIf="mode === 1" matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef>Πλοήγηση σε</th>
            <td mat-cell *matCellDef="let action"> {{action.title}} </td>
          </ng-container>

          <ng-container *ngIf="mode === 0" matColumnDef="alternate_description">
            <th mat-header-cell *matHeaderCellDef>Περιγραφή</th>
            <td mat-cell *matCellDef="let action"> {{action.alternate_description}} </td>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="actionsColumnsToDisplay; sticky: true"></tr>
          <tr mat-row *matRowDef="let record; columns: actionsColumnsToDisplay"></tr>
        </table>
      </div>

    </div>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayout="row" fxLayoutAlign="center center">
      <button mat-flat-button color="primary" (click)="updateActions()">Ενημέρωση</button>
    </div>
  </mat-card-actions>
</mat-card>
